import { BasicCardVariantType } from '../../../../../../components/basicCard/types/basicCard';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../variants';
import { firstContainerCommonStyles, parentContainerCommonStyles } from '../commonStyles';
export const getRegularDisabledStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [BasicCardVariantType.REGULAR_DISABLED]: {
            parentContainer: {
                ...parentContainerCommonStyles(FOUNDATIONS, SHADOWS),
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
                border_color: FOUNDATIONS.color_accent_disabled_border_100,
                border_width: '0.063rem',
                border_style: 'solid',
            },
            label: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            title: {
                font_variant: TextVariantType.FONT_PARAGRAPH_250,
                font_weight: FONT_WEIGHT.font_weight_600,
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            subtitle: {
                font_variant: TextVariantType.FONT_PARAGRAPH_350,
                font_weight: FONT_WEIGHT.font_regular,
                color: FOUNDATIONS.color_accent_disabled_font_50,
            },
            firstContainer: {
                ...firstContainerCommonStyles(FOUNDATIONS, FONT),
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
            },
            secondContainer: {
                background_color: FOUNDATIONS.color_accent_disabled_bg_100,
            },
        },
    };
};
//# sourceMappingURL=regularDisabled.js.map